import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import { mobileAppDownloadLink } from '@/constants/common';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { customAnalyticsEvent } from '@/utility/analytics';

// STYLES
import { DialogStyled } from './styles';

const heroImg = getS3ImageUrl('/content/download-app-dialog-mobile.png');

const DialogDownloadApp = props => {
  const [t] = useTranslation();

  const { partnerSettings } = useSelector(({ partner: partnerStore }) => ({
    partnerSettings: partnerStore.data?.settings || {},
  }));

  const downloadLink = partnerSettings.mobile_app_download_link || mobileAppDownloadLink;

  if (!downloadLink) return null;

  const handleDownloadClick = () => {
    window.open(downloadLink, '_blank', 'noopener,noreferrer');

    customAnalyticsEvent('Download App Clicked', { store: '', link: downloadLink });
  };

  return (
    <DialogStyled
      className="dialog-cta--info"
      image={<img src={heroImg} alt="download-app" />}
      title={t('downloadAppDialog.title')}
      buttonConfirmTitle={t('buttons.downloadApp')}
      buttonConfirmProps={{ fullWidth: false, className: 'm-b-15' }}
      onConfirmClick={handleDownloadClick}
      hideCancelButton
      bottomContent={
        <Typography className="dialog-cta__description" variant="subtitle2" align="center">
          {t('downloadAppDialog.description')}
        </Typography>
      }
      {...props}
    />
  );
};

export default React.memo(DialogDownloadApp);
